import React from 'react';

import { DocumentSpecifiqueDto } from 'lib_api/lib/api/gen';

import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';

import FormDelete from './FormDelete';

interface ModalDeleteProps {
  close: () => void;
  visible: boolean;
  onConfirm: (document: DocumentSpecifiqueDto) => void;
  document?: DocumentSpecifiqueDto;
}

export default function ModalDelete({
  close,
  visible,
  document,
  onConfirm,
}: ModalDeleteProps): React.ReactElement {
  function handleConfirm() {
    if (document) {
      onConfirm(document);
    }
  }

  return (
    <BaseModal
      width={BaseModalWidthUtils.largeWidth}
      isVisible={visible}
      closeModal={close}
    >
      <FormDelete
        name={document?.name}
        utilisateurDestinataire={document?.utilisateurDestinataire}
        onClose={close}
        onConfirm={handleConfirm}
      />
    </BaseModal>
  );
}
